// extracted by mini-css-extract-plugin
module.exports = {"overlay":"CustomModal_overlay__Szqw_","noBackground":"CustomModal_noBackground__2YOQo"};